import Siprec, { fetch, request } from './factory/Siprec'
import Locale from '@/locale'

let Configuration = Siprec({
  name: 'configurations',
  methods: {
    getCurrent (user) {
      if (user.company && user.company._links.configuration) {
        return fetch(user.company._links.configuration.href, 'configuration', {
          include: [['certificates', 'user']]
        })
      }
      return Promise.resolve(null)
    },
    setKey (configuration, key) {
      let url = configuration._self
      return request(
        {
          method: 'PUT',
          url: `${url}/changeenckey`,
          data: {
            encryptionKey: key
          }
        })
        .then(result => result.data)
    },
    setPassword (configuration, password) {
      let url = configuration._self
      return request(
        {
          method: 'PUT',
          url: `${url}/changepwd`,
          data: {
            password
          }
        })
        .then(result => result.data)
    }
  },
  enums: {
    encrypt: {
      NONE: Locale.t('configuration.basic.encryption.none'),
      // PASSWORD: Locale.t('configuration.basic.encryption.password'),
      KEY: Locale.t('configuration.basic.encryption.key')
    },
    compression: {
      PCM: Locale.t('configuration.basic.compressions.pcm'),
      FLAC: Locale.t('configuration.basic.compressions.flac'),
      MP3: Locale.t('configuration.basic.compressions.mp3')
    }
  }
})
export default Configuration



// WEBPACK FOOTER //
// ./src/models/Configuration.js